<template lang="pug">
  .box.margin-top-10.card-renovacion.text-center
    div(v-if="idSolicitud")
      span Hay una solicitud de renovación con estado&nbsp;
      strong {{ descripcionEstado }}
    div(v-else)
      span Pedir renovación de contrato para&nbsp;
      span.bold.hint--top(:aria-label="'Empleado: ' + codigo") {{nombre}}
      br
      br
      div
        span.little-text Ingresa los meses de renovación
        .control.text-center
          input.input(
            type="number",
            v-model="mesesARenovar"
            :disabled="disableMeses"
          )
        span.little-text.text-center o activa el check de indeterminado
        br
        label.checkbox
          input(type="checkbox", v-model="indeterminado")
          |  Contrato indeterminado
      br
      .display-flex.jc-center
        .button(
          @click="pedirRenovacion(false)"
          :class="{'is-loading': isSaving}"
        ) Pedir renovacion
        .button.is-danger.margin-left-5(
          @click="pedirRenovacion(true)"
          :class="{'is-loading': isSaving}"
        ) No se renovará

</template>

<script>
import { apiPost, notify } from '../util/general'
export default {
  name: 'pedir_una_renovacion_component',
  data () {
    return {
      mesesARenovar : '3',
      indeterminado : 0,
      disableMeses  : false,
      isSaving      : false
    }
  },
  props: ['codigo', 'nombre', 'idSolicitud', 'descripcionEstado'],
  watch: {
    indeterminado (value) {
      if (value) {
        this.mesesARenovar = ''
        this.disableMeses = true
      } else {
        this.mesesARenovar = '3'
        this.disableMeses = false
      }
    }
  },
  created () {
  },
  methods: {
    pedirRenovacion (noRenovar) {
      var vm = this

      if (noRenovar) {
        vm.indeterminado = 0
        vm.mesesARenovar = 0
      } else {
        if (!vm.indeterminado && vm.mesesARenovar < 1) {
          notify(vm, 'error', 'Error', 'Ingrese un número de meses correcto para renovar')
          return
        }
      }

      vm.isSaving = true
      var obj = {
        codigo        : vm.codigo,
        mesesARenovar : vm.mesesARenovar,
        indeterminado : vm.indeterminado,
        noRenovar     : noRenovar
      }

      apiPost(vm, '/contratos/solicitud/renovacion', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')
        vm.$emit('closeRefresh')
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .bold
    font-weight bold
  .little-text
    font-size 12px
    color #9a9a9a

  .input
    max-width: 60px;
</style>



// WEBPACK FOOTER //
// Component_Contratos_Pedir_Una_Renovacion.vue?632c6d5c